const domains = [
  'app.staging.flodesk.com', // add or remove domains (without https or trailing slash)
  'app.flodesk.com',
];

const initUTM = () => {
  const queryParams = [
    'utm_medium', // add or remove query parameters you want to transfer
    'utm_source',
    'utm_device',
    'utm_campaign',
    'utm_adgroup',
    'utm_extension',
    'utm_term',
    'utm_landingpage',
    'utm_content',
  ];

  // borrowed from https://stackoverflow.com/questions/831030/
  // a function that retrieves the value of a query parameter
  // eslint-disable-next-line consistent-return
  function getQueryParam(name) {
    // eslint-disable-next-line no-cond-assign, no-param-reassign
    if ((name = new RegExp(`[?&]${encodeURIComponent(name)}=([^&]*)`).exec(window.location.search)))
      return decodeURIComponent(name[1]);
  }

  // decorates the URL with query params
  function decorateUrl(urlToDecorate) {
    // eslint-disable-next-line no-param-reassign
    urlToDecorate = urlToDecorate.indexOf('?') === -1 ? `${urlToDecorate}?` : `${urlToDecorate}&`;
    const collectedQueryParams = [];
    for (let queryIndex = 0; queryIndex < queryParams.length; queryIndex += 1) {
      if (getQueryParam(queryParams[queryIndex])) {
        collectedQueryParams.push(
          `${queryParams[queryIndex]}=${getQueryParam(queryParams[queryIndex])}`,
        );
      }
    }
    return urlToDecorate + collectedQueryParams.join('&');
  }

  // do not edit anything below this line
  const links = document.querySelectorAll('a');

  // check if links contain domain from the domains array and then decorates
  for (let linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
    for (let domainIndex = 0; domainIndex < domains.length; domainIndex += 1) {
      if (
        links[linkIndex].href.indexOf(domains[domainIndex]) > -1 &&
        links[linkIndex].href.indexOf('#') === -1
      ) {
        links[linkIndex].href = decorateUrl(links[linkIndex].href);

        if (links[linkIndex].href.endsWith('?')) {
          links[linkIndex].href = links[linkIndex].href.slice(0, -1);
        }
      }
    }
  }
};

const initSource = () => {
  const sourcePaths = {
    '/': 'home',
    '/email': 'email',
    '/checkout': 'checkout',
    '/pricing': 'pricing',
  };
  const source = sourcePaths[window.location.pathname];
  const links = document.querySelectorAll('a') || [];

  if (!source || links.length === 0) {
    return;
  }

  const params = {
    'fd-source': source,
  };

  links.forEach(link => {
    if (domains.some(domain => link.href.includes(domain))) {
      const queryString = new URLSearchParams(params).toString();
      const hasQueryParams = link.href.includes('?') && link.href.includes('&');
      // eslint-disable-next-line no-param-reassign
      link.href += hasQueryParams ? `&${queryString}` : `?${queryString}`;
    }
  });
};

(() => {
  initUTM();
  initSource();
})();
